import { useEffect, useState } from "react";
import { adminService } from "../../../../services/admin-service";
import { AdminPageHeader, AdminPanel, EmptyState, StatusBadge } from "./admin-ui";

function AdminSiteContentPage() {
    const [blocks, setBlocks] = useState([]);
    const [message, setMessage] = useState("");

    const load = () => adminService.siteContent().then((data) => setBlocks(data.blocks || [])).catch((error) => setMessage(error.message));

    useEffect(() => {
        load();
    }, []);

    const update = (index, key, value) => {
        setBlocks((current) => current.map((block, blockIndex) => blockIndex === index ? { ...block, [key]: value } : block));
    };

    const save = async (block) => {
        try {
            await adminService.updateSiteContent(block.block_key, block);
            setMessage("Content block saved.");
            load();
        } catch (error) {
            setMessage(error.message);
        }
    };

    return (
        <>
            <AdminPageHeader title="Site Content" subtitle="Homepage and public website control" />
            {message && <div className="alert alert-info">{message}</div>}
            {blocks.length === 0 ? (
                <AdminPanel title="Content Blocks" icon="fa fa-edit"><EmptyState text="No content blocks found." /></AdminPanel>
            ) : blocks.map((block, index) => (
                <AdminPanel title={block.block_key.replace(/_/g, " ")} icon="fa fa-edit" key={block.block_key}>
                    <div className="row">
                        <div className="col-md-6 m-b15">
                            <label className="form-label">Title</label>
                            <input className="form-control" value={block.title || ""} onChange={(event) => update(index, "title", event.target.value)} />
                        </div>
                        <div className="col-md-6 m-b15">
                            <label className="form-label">Image URL</label>
                            <input className="form-control" value={block.image_url || ""} onChange={(event) => update(index, "image_url", event.target.value)} />
                        </div>
                        <div className="col-md-12 m-b15">
                            <label className="form-label">Body</label>
                            <textarea className="form-control" rows="4" value={block.body || ""} onChange={(event) => update(index, "body", event.target.value)} />
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                        <StatusBadge status={block.enabled ? "active" : "inactive"} />
                        <button className="site-button" type="button" onClick={() => save(block)}>Save Block</button>
                    </div>
                </AdminPanel>
            ))}
        </>
    );
}

export default AdminSiteContentPage;
